import actionTypes from '../actions/actionTypes'

const defaultState = {
	uid: '',
	metadata: null,
}

function updateMedata(state, action) {
	return {
		...state,
		metadata: action.metadata,
	}
}

const lessonSessionReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.LESSON_SESSION_METADATA_SUCCESS:
			return updateMedata(state, action)
		default:
			return state
	}
}

export default lessonSessionReducer
